import { connect } from "react-redux";
import { FaCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

import { GetPendingWorkout } from "../../../redux/v2/workout/actions";

import Badge from "./Badge";
import usePrograms from "../../../hooks/usePrograms";
import { apiCallV2 } from "../../../utils/api";
import toast from "react-hot-toast";

function WelcomeMessage(props) {
    const navigate = useNavigate();

    const { challenge, minimal = false, confetti, Program, User } = props;
    const { allWorkoutHistory, selectedPrograms } = User;
    const { programs } = Program;
    const { account } = props.User;
    const selected_program = account?.user?.selected_program || "";
    const { programsList } = usePrograms({ programs });

    let sp = selected_program?.split(",");
    let filtered = [...programsList];

    if (challenge?.type == "all") { //ALL TYPES OF WORKOUTS
    } else if (challenge?.type == "program") { // SPECIFIC PROGRAM - Pass Program ID
        filtered = filtered.filter(p => p.id == challenge?.program);
    } else if (challenge?.type == "steps") { // HEALTHKIT STEPS
    } else { // THIS IS EXPECTED/SHOULD BE PROGRAM TYPE
        filtered = filtered.filter(p => p.type == challenge?.type);
    }

    let hasEligible = false;
    for (let x = 0; x < filtered.length; x++) {
        if (sp?.includes(filtered[x].key + "")) {
            hasEligible = true;
            break;
        }
    }

    return (
        <div id="challenge-welcome-message" className={minimal ? "minimal" : ""}>

            {
                !minimal && <div id="cwm-badge">
                    <Badge isComplete={true} challenge={null} />
                </div>
            }

            {
                !minimal && <div id="cwm-stmt">
                    <h4>YOU GOT THIS!</h4>
                    <p>Get started by selecting one of the programs below and completing a workout!</p>
                </div>
            }

            <div id="cwm-eligible-prog">

                <div id="cwm-ep-header">
                    <h5>ELIGIBLE PROGRAMS</h5>
                    {hasEligible && <h5 className="regular"><FaCircle /> Your Programs</h5>}
                    {!hasEligible && <h5 className="regular">Select a program below to get started!</h5>}
                </div>
                <div id="cwm-ep-programs">
                    {
                        filtered?.map((p) => {

                            let isEligible = sp?.includes(p?.key + "");

                            return (
                                <div onClick={async () => {
                                    const toastId = toast.loading("Preparing workout...");

                                    const res = await apiCallV2(
                                        "GET",
                                        "get-pending-workout",
                                        "",
                                        localStorage.getItem("access-token"),
                                        p.level ? {
                                            "wo.program_id": p.id,
                                            "wo.program_detail_id": p.level
                                        } : {
                                            "wo.program_id": p.id,
                                        }
                                    );
                                    toast.dismiss();

                                    if (isEligible) {
                                        navigate(`/workout?workout=${res?.data?.workout?.workout_id}`);
                                    } else {
                                        navigate(`/program-detail?program=${p.id}` + ((p.level != 0) ? `&level=${p.level}` : ""));
                                    }

                                }} className={isEligible ? "eli" : ""}><p>{p?.name}</p></div>
                            )
                        })
                    }
                </div>
            </div>


            {
                confetti
            }

        </div >
    );
}


const mapStateToProps = (state) => ({
    Program: state.Program,
    User: state.User,
});

export default connect(mapStateToProps, {
    GetPendingWorkout,
})(WelcomeMessage);